import { ProvisioningProgress, SetupState, SetupStep } from 'services/payroll/api/generated/v1/model';

/**
 * `SetupState` payloads for stories and tests of the surfaces that read it: the member's setup
 * status card and the Hub's setup progress view.
 */

export const SETUP_STEPS = [
    'intro_question',
    'review_company_info',
    'company_bank_account',
    'pay_schedule',
    'federal_tax',
    'state_tax',
    'sign_documents',
];

const COMPLETED_AT = '2026-08-14T09:02:00Z';

export function setupSteps(completedCount: number): SetupStep[] {
    return SETUP_STEPS.map((step, index) => ({
        step,
        status: index < completedCount ? 'complete' : 'incomplete',
        completed_at: index < completedCount ? COMPLETED_AT : null,
    }));
}

/** Three of seven steps done, on `pay_schedule`. */
export function setupStateFixture(overrides: Partial<SetupState> = {}): SetupState {
    return {
        setup_route: 'standard',
        current_step: 'pay_schedule',
        onboarding_status: 'in_progress',
        steps: setupSteps(3),
        provisioning: null,
        funding_account: null,
        completed_at: null,
        ...overrides,
    };
}

export function provisioningFixture(overrides: Partial<ProvisioningProgress> = {}): ProvisioningProgress {
    return {
        overall_status: 'in_progress',
        is_stalled: false,
        task_statuses: { company_add_locations: 'completed', company_add_pay_schedule: 'in_progress' },
        retry_counts: {},
        started_at: COMPLETED_AT,
        completed_at: null,
        ...overrides,
    };
}
